module.exports = __webpack_public_path__ + "static/media/Achievement100.caef3cec.jpg";